<template>
  <div class="v2-who-are-we">
    <div class="player">
      <app-frame>
        <player id="who-are-we" ratio="16x9" :poster="getFreeareaVideoPoster(`whoweare_poster.png`)" :source="source" />
      </app-frame>
    </div>

    <h1 class="d-block d-md-none text-center py-3 px-2">
      {{ t("We Are Ersties") }}
    </h1>

    <span class="bg-sticker dildo-pink d-none d-lg-block">
      <img v-lazy="dildoPinkSticker" :alt="`sticker dildo`" width="75" height="77" />
    </span>

    <span class="bg-sticker plug d-none d-lg-block">
      <img v-lazy="plugSticker" :alt="`sticker plug`" width="57" height="56" />
    </span>

    <span class="bg-sticker star-pink-light d-none d-lg-block">
      <img v-lazy="starPinkLightSticker" :alt="`sticker star pink`" width="22" height="22" />
    </span>

    <span class="bg-sticker hand d-none d-lg-block">
      <img v-lazy="handSticker" :alt="`sticker hand`" width="46" height="34" />
    </span>

    <span class="bg-sticker bow d-none d-lg-block">
      <img v-lazy="bowSticker" :alt="`sticker bow`" width="50" height="51" />
    </span>

    <span class="bg-sticker pop-up-window d-none d-lg-block">
      <img v-lazy="popUpWindowPinkSticker" :alt="`sticker window`" width="114" height="69" />
    </span>

    <span class="bg-sticker heart-pink-left d-none d-lg-block">
      <img v-lazy="heartPinkSmallSticker" :alt="`sticker heart`" width="42" height="54" />
    </span>

    <span class="bg-sticker heart-pink-right d-none d-lg-block">
      <img v-lazy="heartPinkSmallSticker" :alt="`sticker heart`" width="35" height="45" />
    </span>

    <span class="bg-sticker ok-hand d-none d-lg-block">
      <img v-lazy="okHandSticker" :alt="`sticker ok`" width="50" height="72" />
    </span>

    <span class="bg-sticker star-mint-right d-none d-lg-block">
      <img v-lazy="starMintDarkSticker" :alt="`sticker star mint`" width="18" height="18" />
    </span>

    <span class="bg-sticker boobs-pop-up d-none d-lg-block">
      <img v-lazy="boobsPopUpSticker" :alt="`sticker boobs`" width="85" height="69" />
    </span>

    <span class="bg-sticker butt d-none d-lg-block">
      <img v-lazy="buttSticker" :alt="`sticker butt`" width="50" height="45" />
    </span>

    <span class="bg-sticker star-pink-right d-none d-lg-block">
      <img v-lazy="starPinkLightSticker" :alt="`sticker star pink`" width="18" height="18" />
    </span>

    <span class="bg-sticker dildo-nude d-none d-lg-block">
      <img v-lazy="dildoNudeSticker" :alt="`sticker dildo nude`" width="95" height="104" />
    </span>

    <span class="bg-sticker heart-pink-right-big d-none d-lg-block">
      <img v-lazy="pinkHeartSticker" :alt="`sticker heart pink`" width="55" height="50" />
    </span>

    <span class="bg-sticker star-nude d-none d-md-block">
      <img v-lazy="starNudeLightSticker" :alt="`sticker star nude`" width="24" height="24" />
    </span>

    <span class="bg-sticker star-mint d-none d-md-block">
      <img v-lazy="starMintLightSticker" :alt="`sticker star mint`" width="32" height="32" />
    </span>

    <span class="bg-sticker star-pink">
      <img v-lazy="starPinkDarkSticker" :alt="`sticker star pink`" width="16" height="16" />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { getFreeareaVideoPoster, getWhoWeAreVideoUrl } from "@/utils/mediaHelper";
import AppFrame from "@/components/v2/app-frame/index.vue";
import Player from "@/components/player/index.vue";
import dildoPinkSticker from "@/assets/v2/images/stickers/dildo-pink.svg";
import plugSticker from "@/assets/v2/images/stickers/plug.svg";
import starPinkLightSticker from "@/assets/v2/images/stickers/star-pink-light.svg";
import handSticker from "@/assets/v2/images/stickers/hand.svg";
import bowSticker from "@/assets/v2/images/stickers/bow.svg";
import popUpWindowPinkSticker from "@/assets/v2/images/stickers/pop-up-window-pink.svg";
import heartPinkSmallSticker from "@/assets/v2/images/stickers/heart-pink-small.svg";
import okHandSticker from "@/assets/v2/images/stickers/ok-hand.svg";
import starMintDarkSticker from "@/assets/v2/images/stickers/star-mint-dark.svg";
import boobsPopUpSticker from "@/assets/v2/images/stickers/boobs-pop-up.svg";
import buttSticker from "@/assets/v2/images/stickers/butt.svg";
import dildoNudeSticker from "@/assets/v2/images/stickers/dildo-nude.svg";
import pinkHeartSticker from "@/assets/v2/images/stickers/pink-heart.svg";
import starNudeLightSticker from "@/assets/v2/images/stickers/star-nude-light.svg";
import starMintLightSticker from "@/assets/v2/images/stickers/star-mint-light.svg";
import starPinkDarkSticker from "@/assets/v2/images/stickers/star-pink-dark.svg";

defineOptions({
  name: "who-are-we",
});

const { locale, t } = useI18n();

const source = computed(() => {
  return getWhoWeAreVideoUrl(locale.value === "de" ? "de" : "en");
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
